import React from "react";
import t from "lib/i18n";
// import FindStation from "components/FindStation";
import Checkbox from "components/ui/Checkbox";
import "styles/components/via-find.scss";
import useConfig from "hooks/useConfig";

const ViaFind = ({ className, onChange, via }) => {
  const { gatwickRoutes } = useConfig();
  return (
    <div className="otrl-jp__via-find">
      <Checkbox
        label={t("station.via")}
        ariaLabel={t("station.via.aria")}
        labelClassName="otrl-jp__via-find__label"
        name="via"
        disabled={gatwickRoutes}
        onChange={onChange}
        selected={via}
        value="via"
      />
      {/* <FindStation /> */}
    </div>
  );
};

export default ViaFind;
